import React from "react";
import { APP_CONFIG } from "../../../config";
import { LogoWrapper } from "./Logo.styles";

interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
}

export const Logo: React.FC<LogoProps> = ({ className, style }) => {
  return (
    <LogoWrapper className={className} style={style}>
      {APP_CONFIG.APP_NAME}
    </LogoWrapper>
  );
};
